import img from '../../../images/projects/memory.png'
import { useEffect } from 'react';

import paths from '../../../config/paths'

export default function Memory({ visited }) {

    useEffect(() => {
        visited();
    }, []);

    return(
        <main className="relative flex flex-col justify-evenly">
            <div className='video'>
                <img src={img}></img>
            </div>
            <h2 className='title'>Memory</h2>
            <p className='content'>Projet personnel pour m'entraîner sur mes skills Bootstrap et Javascript. L'idée était de créer un jeu de memory avec des cartes, un timer, un bouton pour rejouer et des effets 3D sur les cartes.</p>
            <p className='skills'>HTML/CSS | Bootstrap | Javascript</p>
            <div className='project-button'>
                <a className='website' target="_blank" href="https://secret-memory.netlify.app/">Le site</a>
                <a className='github' target="_blank" href="https://github.com/Coussecousse/SECRET-MEMORY"><i className="fa-brands fa-github"></i>Github</a>
            </div>
            <div className='project-button big-buttons'>
                <a href={paths.ROLLIN_BATTLE} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Précédent projet</a>
                <a href={paths.PROJECTS} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Revenir aux projets</a>
                <a href={paths.MLP} className='backProject'>Prochain projet<i className="fa-solid fa-arrow-right ml-2"></i></a>
            </div>
        </main>
    )
}